import React, { useContext, useState } from "react";
import "./Verticle_Categories.css";
import { Context } from "../../../../utils/context";

const Verticle_Categories = ({
  category,
  onClick, //for shop
  onCategorySelect,
  category_image,
  setSelectId,
  selectId,
  subcategory_name,
}) => {
  
  const { IMG_URL } = useContext(Context);
  const [activeCat, setActiveCat] = useState("All");

  const handleClick = (item) => {
    setSelectId(item === "All" ? "" : item.id);
  };

  return (
    <section className="Verticle_Categories">
      <div className="all_cats_holder">
        {/* ALL */}
        <div
          className={`cat_holder ${!selectId ? "active" : ""}`}
          onClick={() => handleClick("All")}
        >
          <div className="img_holder">
            <img
              className="img"
              src={
                category_image
                  ? IMG_URL + category_image
                  : "/assets/Image/product/e-cart.png"
              }
            />
          </div>
          <p className="cat_name">{subcategory_name || "All"}</p>
        </div>

        {category?.map((item) => (
          <div
            key={item.id}
            className={`cat_holder ${Number(selectId) === Number(item.id) ? "active" : ""}`}
            onClick={() => handleClick(item)}
          >
            <div className="img_holder">
              <img src={IMG_URL + item.image} className="img" />
            </div>
            <p className="cat_name">{item.name}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Verticle_Categories;
